import React from 'react';
import { Lock } from 'lucide-react';
import { useT } from '../context/LanguageContext';

/** Centered "Access denied" card for gated pages, naming exactly which permission code is missing. */
export default function AccessDenied({ perm, what }) {
  const { t } = useT();
  // Default resolved in the body, not in the signature — the hook isn't available there.
  const target = what || t('dashboard.accessDenied.thisPage');
  return (
    <div className="min-h-[calc(100vh-56px)] bg-slate-50 flex items-center justify-center p-8">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-lg p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-rose-50 text-rose-600 flex items-center justify-center">
          <Lock size={24} />
        </div>
        <h2 className="text-lg font-semibold text-slate-900">{t('dashboard.accessDenied.title')}</h2>
        <p className="text-sm text-slate-600 mt-2">
          {t('dashboard.accessDenied.body', { what: target })}
        </p>
        {perm && (
          <p className="text-xs text-slate-500 mt-3">
            {t('dashboard.accessDenied.askAdminPrefix')}{' '}
            <code className="bg-slate-100 px-1.5 py-0.5 rounded text-[11px]">{perm}</code>{' '}
            {t('dashboard.accessDenied.askAdminSuffix')}
          </p>
        )}
      </div>
    </div>
  );
}
